import React from 'react';
import { Check } from 'lucide-react';

// A verified-route "receipt" rendered as the rider's OWN turn right after they set or update the
// route in the map popup (see CustomerApp onConfirm -> a user message carrying `route`). It reflects
// the VERIFIED locations (coords-backed city/state + airport flag) so the rider has confidence the
// system captured exactly what they picked — before any quote lands, and again whenever they edit.

function cityState(p) {
  return [p?.city, p?.state].filter(Boolean).join(', ');
}

function Waypoint({ place, kind }) {
  const title = kind === 'from' ? 'Pickup' : kind === 'to' ? 'Destination' : 'Stop';
  const dot = kind === 'via' ? 'bg-peoria-surface border-2 border-peoria-red' : 'bg-peoria-red';
  return (
    <div className="flex items-start gap-3">
      <span className={`w-2.5 h-2.5 mt-1.5 rounded-full shrink-0 ${dot}`} />
      <div className="min-w-0">
        <div className="text-11 font-medium text-peoria-muted uppercase tracking-brand">{title}</div>
        <div className="text-13 font-medium text-peoria-text mt-0.5 flex items-center gap-1.5">
          {place?.isAirport && <span className="text-peoria-red" aria-label="airport">✈</span>}
          <span className="truncate">{place?.label || '—'}</span>
        </div>
        {cityState(place) && <div className="text-11 text-peoria-muted mt-0.5">{cityState(place)}</div>}
      </div>
    </div>
  );
}

export function RouteCard({ route, updated }) {
  if (!route || (!route.from && !route.to)) return null;
  const { from, to, stops = [] } = route;
  return (
    <div className="max-w-[80%] rounded-card rounded-br-md bg-peoria-surface2 border border-peoria-border shadow-card px-4 py-3 text-left">
      <div className="flex items-center gap-1.5 mb-3">
        <span className="w-5 h-5 rounded-full bg-green-500/10 text-green-700 flex items-center justify-center">
          <Check size={13} strokeWidth={3} />
        </span>
        <span className="text-13 font-semibold text-peoria-text">{updated ? 'Route updated' : 'Route set'}</span>
        <span className="ml-auto text-11 font-medium text-green-700">Verified</span>
      </div>
      <Waypoint place={from} kind="from" />
      {stops.map((s, i) => (
        <React.Fragment key={i}>
          <div className="ml-[4px] w-0.5 h-3 bg-peoria-border" />
          <Waypoint place={s} kind="via" />
        </React.Fragment>
      ))}
      <div className="ml-[4px] w-0.5 h-3 bg-peoria-border" />
      <Waypoint place={to} kind="to" />
    </div>
  );
}

export default RouteCard;
